import { useRef } from 'react';
import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import { font } from 'asserts/styles/fonts';
import { ReactComponent as IconExpand } from 'asserts/icons/ic_expand_lined_download.svg';
import { ReactComponent as IconReFlesh } from 'asserts/icons/ic_reflesh_alt_lined_download.svg';

interface DirectionListProps {
  HeaderTitle: string;
  openViewer: () => void;
}

const InstallList = ({ HeaderTitle, openViewer }: DirectionListProps) => {
  const settingData = [
    {
      title: 'Step1',
      text: '프로그램 설치파일 다운로드후실행 파일 클릭',
      dec: '‘다운로드’클릭하여 파일 다운로드 → 다운로드 프로그램 더블클릭',
      img: 'install1'
    },
    {
      title: 'Step2',
      text: '프로그램 설치',
      dec: '설치 시작 → 언어선택 → 설치 폴더 선택 → 시작 메뉴 구성 → 설치 계속',
      img: 'install2'
    },
    {
      title: 'Step3',
      text: '구성요소 설치',
      dec: '* 엑스바디프로그램이 사용하는 서브 프로그램으로 기존에 해당 프로그램이 설치 되어 있는 경우에는 “닫기” 클릭 후설치과정 진행',
      img: 'install3'
    },
    {
      title: 'Step4',
      text: '설치완료, 프로그램실행',
      img: 'install4',
      dec: '* 최초 설치완료 이후부터는 바탕화면 MetaFamilyLauncher 더블클릭하여프로그램 실행'
    }
  ];
  const gifRef = useRef<HTMLImageElement>(null);

  const handleClickGifReload = () => {
    if (gifRef.current) {
      gifRef.current.src = '';
      gifRef.current.src = '/images/install.gif';
    }
  };

  return (
    <>
      <div className="backgroundColor">
        <SettingWrapper>
          <h2>{HeaderTitle}</h2>
          <ImageWrapper>
            <img ref={gifRef} src="/images/install.gif" alt="설치화면" loading="lazy" />
            <IconWrapper>
              <div style={{ cursor: 'pointer' }} onClick={handleClickGifReload}>
                <IconReFlesh />
              </div>
              <div style={{ cursor: 'pointer' }} onClick={openViewer}>
                <IconExpand />
              </div>
            </IconWrapper>
          </ImageWrapper>
          <div>
            {settingData.map((data) => {
              const { title, text, dec, img } = data;
              const imgSrc = `/images/${img}.png`;
              return (
                <Contents key={text}>
                  <TextWrapper>
                    <h3>{title}</h3>
                    <div>
                      <h4>{text}</h4>
                      <p>{dec}</p>
                    </div>
                  </TextWrapper>
                  <img src={imgSrc} alt="설정 이미지" loading="lazy" />
                </Contents>
              );
            })}
          </div>
        </SettingWrapper>
      </div>
    </>
  );
};

export default InstallList;

const SettingWrapper = styled.div`
  margin: 0 auto;
  padding: 128px 0;
  background: ${color.blue50};

  h2 {
    text-align: center;
    ${font.d1_bold};
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 48px;
    width: 890px;
    margin: 0 auto;
    padding-top: 64px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;

  img {
    width: 890px;
    height: 520px;
    border-radius: 16px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  position: absolute;
  bottom: 24px;
  right: 24px;

  div {
    width: 52px;
    height: 52px;
    padding: 14px;
    border-radius: 32px;
    background: ${color.opacityBlack04};
  }
`;

const Contents = styled.div`
  display: flex;
  gap: 40px;

  img {
    width: 420px;
    height: 240px;
    border-radius: 16px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  width: 430px;

  div {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  h3 {
    ${font.h1_bold};
    color: ${color.navyLight};
  }

  h4 {
    color: var(--Basic-Black-2, #0c0c0c);
    ${font.h4_medium};
  }

  p {
    color: ${color.gray600};
    ${font.caption1_regular};
  }
`;
